<template>
  <div class="fair-survey-step">
    <div class="fair-survey-step__head">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <div
      class="fair-survey-step__options"
      role="radiogroup"
      :aria-label="step.title"
    >
      <button
        v-for="occasion in step.occasions"
        :key="occasion.value"
        type="button"
        role="radio"
        class="fair-survey-step__option"
        :class="{
          'fair-survey-step__option--selected':
            selectedOccasion === occasion.value,
        }"
        :aria-checked="selectedOccasion === occasion.value"
        @click="pickOccasion(occasion.value)"
      >
        <FairRadioButtonIndicator :selected="selectedOccasion === occasion.value" />
        <span class="fair-survey-step__option-label">{{ occasion.label }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { FairRadioButtonIndicator } from '@/ui/primitives/FairRadioButton'
import { useLookModal } from '@/features/look/store'
import type { LookStep } from '@/features/look/types/look-config'

interface Props {
  step: LookStep & { type: 'occasion' }
}

const props = defineProps<Props>()
const lookStore = useLookModal()

const selectedOccasion = ref<string | null>(null)

function pickOccasion(value: string) {
  selectedOccasion.value = value
  updateOccasion()
}

function updateOccasion() {
  lookStore.updateLookData(props.step.id, selectedOccasion.value)
}

onMounted(() => {
  const data = lookStore.lookModal.lookData
  const savedOccasion = data[props.step.id]
  selectedOccasion.value = savedOccasion || null
})
</script>
